import { createClient } from "@supabase/supabase-js";

let cachedClient = null;

/**
 * Singleton anon Supabase client for public routes (e.g. Link in Bio).
 * Returns null when env is missing so callers can show a safe fallback.
 */
export function getSupabasePublicClient() {
  const url = import.meta.env.VITE_SUPABASE_URL;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  if (!url || !anonKey) {
    return null;
  }

  if (!cachedClient) {
    cachedClient = createClient(url, anonKey, {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false,
      },
    });
  }

  return cachedClient;
}
